import { PlusIcon } from "@/Icons/Plus";
import { Button } from "@/components/button";

import { ComponentProps } from "react";

import { twMerge } from "tailwind-merge";

type AddButtonProps = Omit<ComponentProps<typeof Button>, "label" | "color">;

export const AddButton: React.FC<AddButtonProps> = (props) => {
  return (
    <Button
      {...props}
      label={<PlusIcon height={16} width={16} />}
      color="secondary"
      className={twMerge(
        "flex h-8 w-8 min-w-0 items-center justify-center px-0",
        props.className,
      )}
    />
  );
};
